export const EnvLabel = () => {
  return process.env.REACT_APP_ENV !== 'prod' &&
    process.env.REACT_APP_ENV !== 'production' ? (
    <div
      className={
        'fixed bg-lime text-xxxs font-bold fixed z-100 rounded-lg py-0.5 px-2 uppercase left-8 top-10'
      }
    >
      {process.env.REACT_APP_ENV}
    </div>
  ) : (
    <></>
  );
};
